import { render, staticRenderFns } from "./CodCourierList.vue?vue&type=template&id=1303a987&scoped=true"
import script from "./CodCourierList.vue?vue&type=script&lang=js"
export * from "./CodCourierList.vue?vue&type=script&lang=js"
import style0 from "./CodCourierList.vue?vue&type=style&index=0&id=1303a987&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1303a987",
  null
  
)

export default component.exports